<section class="flex justify-content-center mt-4">
    <div class="card-table col-12">
        <div>
            <h1 class="font-roboto-condensed font-23 title-blue text-uppercase font-normal mb-0">{{'msg.actividadesAsociadasTrámite' | translate}}</h1>
        </div>
        <div>
            <p class="color-general-blue">{{title}}</p>
        </div>
        <p-tabView [(activeIndex)]="activeTabIndex" (activeIndexChange)="activeIndexChange($event)" class="w-full">
            <p-tabPanel *ngIf="tabs[0].visible">
                <ng-template pTemplate="header">
                    <div class="flex gap-1 align-items-center">
                        <i class="pi pi-history"></i>
                        <span>
                            {{tabs[0].label |translate}}
                        </span>
                    </div>
                </ng-template>
                <app-actividad [actividadId]="actividadId" [tramRegistroId]="tramRegistroId"></app-actividad>
            </p-tabPanel>
            <p-tabPanel>
                <ng-template pTemplate="header">
                    <div class="flex gap-1 align-items-center">
                        <i class="pi pi-file"></i>
                        <span>
                            {{tabs[1].label |translate}}
                        </span>
                    </div>
                </ng-template>
                <app-tramite-historial [tramRegistroId]="tramRegistroId" class="w-full"></app-tramite-historial>
            </p-tabPanel>
            <p-tabPanel *ngIf="tabs[2].visible">
                <ng-template pTemplate="header">
                    <div class="flex gap-1 align-items-center">
                        <i class="pi pi-dollar"></i>
                        <span>
                            {{tabs[2].label | translate}}
                        </span>
                    </div>
                </ng-template>
                <app-factura [tramRegistroId]="tramRegistroId" class="w-full"></app-factura>
            </p-tabPanel>
            <p-tabPanel *ngIf="tabs[3].visible">
                <ng-template pTemplate="header">
                    <div class="flex gap-1 align-items-center">
                        <i class="pi pi-credit-card"></i>
                        <span>
                            {{tabs[3].label | translate}}
                        </span>
                    </div>
                </ng-template>
                <app-pago [tramRegistroId]="tramRegistroId" class="w-full"></app-pago>
            </p-tabPanel>
            <p-tabPanel *ngIf="tabs[4].visible">
                <ng-template pTemplate="header">
                    <div class="flex gap-1 align-items-center">
                        <i class="pi pi-building"></i>
                        <span>
                            {{tabs[4].label | translate}}
                        </span>
                    </div>
                </ng-template>
                <app-empresa-info [empresaId]="empresaId" class="w-full"></app-empresa-info>
            </p-tabPanel>
        </p-tabView>
    </div>
</section>
